import { Text } from '@vinted/web-ui';
import useTranslate from 'hooks/useTranslate';
import { jsx as _jsx } from "react/jsx-runtime";

const AdInfo = () => {
  const translate = useTranslate('advertisements');
  return /*#__PURE__*/_jsx("div", {
    className: "ad-info",
    "data-testid": "ad-info",
    children: /*#__PURE__*/_jsx(Text, {
      type: Text.Type.Caption,
      theme: "muted",
      text: translate('advertisement')
    })
  });
};

export default AdInfo;